<div class="fileItemsList" *ngIf="fileItems && fileItems.length; else noFiles">
  <div class="file-row" *ngFor="let item of fileItems">
    <!-- PDF Icon -->
    <mat-icon class="file-icon">picture_as_pdf</mat-icon>

    <!-- File Name -->
    <span class="file-name">{{ item.name }}</span>

    <!-- More menu -->
    <button mat-icon-button [matMenuTriggerFor]="menu" class="more-btn">
      <mat-icon>more_vert</mat-icon>
    </button>

    <!-- Menu Content -->
    <mat-menu #menu="matMenu">
      <!-- <button  mat-menu-item (click)="renameFile(item)">
        <mat-icon>format_size</mat-icon> Rename
      </button>
      <button mat-menu-item (click)="deleteFile(item)">
        <mat-icon>delete_outline</mat-icon> Delete
      </button>
      <button mat-menu-item (click)="viewDetails(item)">
        <mat-icon>visibility</mat-icon> Details
      </button>
      <button mat-menu-item (click)="shareFile(item)">
        <mat-icon>share</mat-icon> Share
      </button> -->
      <button mat-menu-item (click)="downloadFile(item)">
        <mat-icon>cloud_download</mat-icon> Download
      </button>
    </mat-menu>
  </div>
</div>

<ng-template #noFiles>
  
  <div class="no-files">
    <i class="fa fa-folder-open-o" aria-hidden="true"></i>
     <p><strong>No files to display.</strong></p>
  </div>
</ng-template>
